module.exports = __webpack_public_path__ + "03_face.b55099af.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/03_face.png
// module id = ccPC
// module chunks = 0